
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/users/[id]",
      function () {
        return require("private-next-pages/admin/users/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/users/[id]"])
      });
    }
  